import { Hours } from '../shared/hours';
import type { IsoWeekday } from '../date/business-date';

/**
 * Jornada padrão: **44 horas semanais** — segunda a quinta 9h, sexta 8h.
 *
 * Este é o **único lugar** do sistema onde a jornada padrão aparece como número
 * (RN-040, ADR-012). Serve exclusivamente para semear o calendário padrão. Todo
 * cálculo de capacidade lê o `WorkCalendar` — nunca estas constantes.
 *
 * As 44h da CLT não se dividem por cinco em passos de 15 minutos (8,8h não existe na
 * grade), então a semana fecha variando o dia: quatro dias de 9h e um de 8h. A outra
 * forma usual do setor — 8h de segunda a sexta mais 4h no sábado — se escreve no mesmo
 * campo, sem tocar em código.
 *
 * Alterar a jornada de uma obra é editar o calendário dela.
 */
export const DEFAULT_DAILY_QUARTER_HOURS = 36;

export const DEFAULT_DAILY_HOURS = Hours.ofQuarters(DEFAULT_DAILY_QUARTER_HOURS);

/** Segunda a sexta, em numeração ISO. */
export const DEFAULT_WORKING_WEEKDAYS: readonly IsoWeekday[] = [1, 2, 3, 4, 5];

/** Sexta-feira de 8h — é ela que fecha a semana em 44h e não em 45h. */
export const DEFAULT_WEEKDAY_QUARTER_HOURS: Readonly<Partial<Record<IsoWeekday, number>>> = {
  5: 32,
};

/** 4 × 9h + 8h. Usado por teste e por semente; nenhum cálculo depende dele. */
export const DEFAULT_WEEKLY_QUARTER_HOURS = 4 * DEFAULT_DAILY_QUARTER_HOURS + 32;

export const DEFAULT_WORK_CALENDAR_NAME = 'Padrão 44h — Seg a Qui 9h, Sex 8h';

/**
 * Nome do calendário semeado antes da jornada por dia da semana.
 *
 * Serve só para o bootstrap reconhecer o registro que ninguém editou e corrigi-lo de 45h
 * para 44h. Um calendário renomeado foi mexido por alguém e fica como está.
 */
export const LEGACY_WORK_CALENDAR_NAME = 'Padrão 9h — Seg a Sex';

/** Limite físico por recurso por dia (RN-048). Verificado antes da regra de capacidade. */
export const MAX_DAILY_QUARTER_HOURS = 96;

/** Horizonte padrão de alerta de risco de material, em dias (RN-066). */
export const DEFAULT_RISK_HORIZON_DAYS = 7;

/** Fuso padrão das obras (RN-123). */
export const DEFAULT_PROJECT_TIMEZONE = 'America/Sao_Paulo';
